import * as React from "react";
import "../filters.scss";
import {default as OptionSelector} from "../../../../hiberUiKit/src/molecules/OptionSelector/OptionSelector";
import RadioButton, {IRadioButton} from "../../../../hiberUiKit/src/atoms/Buttons/RadioButton";
import {none, option, Option} from "ts-option";
import {DateFilterType, DateFilterTypeName, unitsOfTime} from "./DateFilter";
import DateFilterModel from "../../../../model/workspace/DateFilterModel";
import {DateFilterValueItemApiDto} from "../../../../api/model/rest";
import NumberUtils from "../../../../utils/NumberUtils";
import moment = require("moment");
import DurationConstructor = moment.unitOfTime.DurationConstructor;

interface IProps {
	/**
	 * Input value
	 */
	value: Option<WithinTheLastFilterModel>
	/**
	 * On change callback
	 * @param {Option<WithinTheLastFilterModel>} value
	 */
	onChange: (value: Option<WithinTheLastFilterModel>) => void
	/**
	 * Selected radio button Id
	 */
	selectedRadioButtonId: string
	/**
	 * On select button
	 * @param {string} id
	 */
	onSelectButton: (id: string) => void
}

interface IState {
	/**
	 * Selected unit of time for "Within the last"
	 */
	selectedUnitOfTime: DurationConstructor
	/**
	 * Represents input value for "Within the last" start date
	 * End date represents this moment
	 */
	inputStartValue: string;
}

export default class WithinTheLastFilter extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {
			inputStartValue: props.value.map(v => v.timeValue.toString()).getOrElse(""),
			selectedUnitOfTime: props.value.map(v => v.unitOfTime).getOrElse("minutes"),
		};
		this.onChangeStartInput = this.onChangeStartInput.bind(this);
		this.onChangeSelector = this.onChangeSelector.bind(this);
		this.onChangeCallabck = this.onChangeCallabck.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.selectedRadioButtonId === this.radioButton.value &&
			nextProps.selectedRadioButtonId !== this.radioButton.value) {
			this.resetFilter();
		}
	}

	radioButton: IRadioButton = {
		label: DateFilterTypeName[DateFilterType.WithinTheLast],
		disabled: false,
		value: DateFilterType.WithinTheLast
	};

	render() {
		const radioButtonChecked = (this.props.selectedRadioButtonId === this.radioButton.value);
		return (
			<div className={"c-filter-dates_inputs_row"}>
				<RadioButton radioButton={this.radioButton}
							 onChange={() => this.props.onSelectButton(this.radioButton.value)}
							 checked={radioButtonChecked}
							 onFocus={this.resetFilter}/>
				<input className={"c-filter-dates_input_within-the-last"}
					   type="number"
					   value={this.state.inputStartValue}
					   onChange={this.onChangeStartInput}
					   disabled={!(this.props.selectedRadioButtonId == this.radioButton.value)}/>
				<OptionSelector selectableOptions={unitsOfTime}
								onSelect={this.onChangeSelector}
								disabled={!radioButtonChecked}
								selectedOption={this.state.selectedUnitOfTime}/>
			</div>
		);
	}

	/**
	 * On change in "Within the last" start input
	 */
	onChangeStartInput(e: React.FormEvent<HTMLInputElement>) {
		if (e.currentTarget.value.length == 0 || NumberUtils.isNumber(e.currentTarget.value)) {
			this.setState({inputStartValue: e.currentTarget.value}, this.onChangeCallabck)
		}
	}

	/**
	 * On change in "Within the last" start selector
	 */
	onChangeSelector(selectedUnitOfTime: DurationConstructor) {
		this.setState({selectedUnitOfTime: selectedUnitOfTime}, () => {
			this.onChangeCallabck();
		})
	}

	/**
	 * On any change callback
	 */
	onChangeCallabck() {
		const timeValue = this.state.inputStartValue;
		const unitOfTime = this.state.selectedUnitOfTime;

		if (timeValue && unitOfTime) {
			this.props.onChange(option(new WithinTheLastFilterModel(Number(timeValue), unitOfTime)));
		}
		else {
			this.props.onChange(none);
		}
	}

	/**
	 * Reset filter
	 */
	resetFilter() {
		this.setState({inputStartValue: ""});
	}
}

export class WithinTheLastFilterModel extends DateFilterModel {
	constructor(public readonly timeValue: number,
		public readonly unitOfTime: DurationConstructor) {
		super(DateFilterType.WithinTheLast)
	}

	getDisplayValue(): string {
		return `${super.getDisplayValue()} ${this.timeValue} ${this.unitOfTime}`;
	}

	toQueryJson(): DateFilterValueItemApiDto[] {
		return [{value: this.timeValue * -1, rangeUnit: this.unitOfTime.toUpperCase()}]
	}

	static fromJson(json: DateFilterValueItemApiDto[]) {
		return new WithinTheLastFilterModel(json[0].value * -1, json[0].rangeUnit.toLowerCase() as DurationConstructor)
	}
}
